import fastdom from 'fastdom';
import { partition } from 'rxjs';
import { onArticleCountResultsLoaded$ } from 'features/articleSearchResultsFacets';

const paginationContainer = document.querySelector('[data-component="blog-article-search-results-pagination"]');

// function to display the new permutation for pagination
const displayNewPagination = function() {
    if(paginationContainer) {
        fastdom.mutate(() => {
            paginationContainer.removeAttribute('hidden');
        });
    }
};

// function to hide the pagination
const hiddeCurrentPagination = function() {
    if(paginationContainer) {
        fastdom.mutate(() => {
            paginationContainer.setAttribute('hidden', '');
        });
    }
};

// if the new results counts is more bigger than minumun page size we need to display the pagination
const [displayNewPagination$, hiddeCurrentPagination$] = partition(
    onArticleCountResultsLoaded$, (countResults) => countResults > 20
);
displayNewPagination$.subscribe(displayNewPagination);
hiddeCurrentPagination$.subscribe(hiddeCurrentPagination);

